export default "__VITE_ASSET__$SAW78fO__"